import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqLd = {
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            关于学历提升，您想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            ...faqLd,
          }, null, 2),
        }}
      />
    </section>
  );
}